import React from 'react';

const PageTransition = ({ children }) => {
  return (
    <div className="w-full min-h-screen">
      {children}
    </div>
  );
};

export default PageTransition;
